import {safeLocalStorage} from '../../../util/localStorage';
import {type SortOption} from './useSharedViewsItems';

const NAMED_WORKSPACE_SORT_OPTIONS_KEY = 'namedWorkspaceSortOptions';

export type WorkspacePreferences = {
  sortOption?: SortOption;
  showMyViewsOnly?: boolean;
};

export const getWorkspacePreferences = (
  workspaceRef: string
): WorkspacePreferences => {
  const stored = safeLocalStorage.getItem(NAMED_WORKSPACE_SORT_OPTIONS_KEY);
  if (!stored) {
    return {};
  }
  const preferences = JSON.parse(stored);
  return preferences[workspaceRef] || {};
};

export const setWorkspacePreference = (
  workspaceRef: string,
  key: keyof WorkspacePreferences,
  value: any
) => {
  const stored = safeLocalStorage.getItem(NAMED_WORKSPACE_SORT_OPTIONS_KEY);
  const preferences = stored ? JSON.parse(stored) : {};

  preferences[workspaceRef] = {
    ...preferences[workspaceRef],
    [key]: value,
  };

  safeLocalStorage.setItem(
    NAMED_WORKSPACE_SORT_OPTIONS_KEY,
    JSON.stringify(preferences)
  );
};
